
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"phoenixAccountGetGiftCardTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CommercePaymentGiftCardCertificateTransactionHistoryInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commerce"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payment"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"giftcard"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"certificateTransactionHistory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CommercePaymentGiftCardCertificateTransactionHistorySuccess"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"certificateBalance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"certificateExpirationDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"operatorMessage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pointsBalance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalRows"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"transactionHistory"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"certificateAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"channelID"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"operator"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"storeAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"storeCurrency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"storeName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"storeUser"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"transactionActive"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"transactionID"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"transactionLocalDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"transactionLocalTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"transactionRef"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"transactionServerDatetime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"transactionType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"transactionTypeID"},"arguments":[],"directives":[]}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResponseError"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"errors"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"httpStatus"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":1341}};
    doc.loc.source = {"body":"query phoenixAccountGetGiftCardTransactions($input: CommercePaymentGiftCardCertificateTransactionHistoryInput!) {\n  commerce {\n    payment {\n      giftcard {\n        certificateTransactionHistory(input: $input) {\n          ... on CommercePaymentGiftCardCertificateTransactionHistorySuccess {\n            certificateBalance\n            certificateExpirationDate\n            currency\n            operatorMessage\n            pointsBalance\n            totalRows\n            transactionHistory {\n              edges {\n                node {\n                  amount\n                  certificateAmount\n                  channelID\n                  comments\n                  operator\n                  storeAmount\n                  storeCurrency\n                  storeName\n                  storeUser\n                  transactionActive\n                  transactionID\n                  transactionLocalDate\n                  transactionLocalTime\n                  transactionRef\n                  transactionServerDatetime\n                  transactionType\n                  transactionTypeID\n                }\n              }\n            }\n          }\n          ... on ResponseError {\n            code\n            errors {\n              code\n              message\n            }\n            httpStatus\n          }\n        }\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["phoenixAccountGetGiftCardTransactions"] = oneQuery(doc, "phoenixAccountGetGiftCardTransactions");
        
